// Internal Imports
import { API_ENDPOINTS } from "../../constants";
import { get, put, post, deleteApi } from "../../api/index";

// Destructuring
const { APIS } = API_ENDPOINTS;

// ----- Document table field apis -------
export const fetchTableFieldRows = tableId =>
  new Promise((resolve, reject) => {
    get(`${APIS.TABLE_FIELDS}/${tableId}/rows`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableAPILinkUnlinkService = (docId, fieldId, action = "unlink") =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOCS}/${docId}/fields/${fieldId}?action=${action}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateTableAPICellService = (tableFieldId, payload) =>
  new Promise((resolve, reject) => {
    put(`${APIS.TABLE_FIELDS}/${tableFieldId}/cell`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateTableAPIColService = (tableFieldId, payload) =>
  new Promise((resolve, reject) => {
    put(`${APIS.TABLE_FIELDS}/${tableFieldId}/cols`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableAddRowService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    post(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableAddColService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    post(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableRemoveRowService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableRemoveColService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableAPITypeChangeService = (tableId, action) =>
  new Promise((resolve, reject) => {
    const payload = { table_type: action };
    put(`${APIS.TABLE_FIELDS}/${tableId}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableRowUpdateService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    put(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableReorderColumnService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    post(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableMetaUpdateService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    put(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const tableBatchCellsUpdateService = (tableId, action, payload) =>
  new Promise((resolve, reject) => {
    put(`${APIS.TABLE_FIELDS}/${tableId}/${action}`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
